/** get items column */
import { TagItemTypes } from "../../../badge-and-tag";
import { Image } from "antd";
import { BACKEND_URL_MAIN } from '../../../../utils/util';
export const columns = ()=>{
  return [
    {
      title: "รหัส",
      key: "code",
      dataIndex: "code",
      width: 80,
      align: "center",
      hidden: "true",
    },
    {
      title: "รหัสใบสั่งซื้อ",
      key: "pocode",
      dataIndex: "pocode", 
    },
    {
      title: "รหัสสินค้า",
      key: "stcode",
      dataIndex: "stcode", 
    },
    {
      title: "ชื่อสินค้า",
      dataIndex: "stname",
      key: "stname",
    },
    {
      title: "ราคาต่อหน่วย",
      dataIndex: "price",
      key: "price",
    },    
    {
      title: "ส่วนลด(%)",
      dataIndex: "discount",
      key: "discount",
      width: "7%",
      align: "right",
      className: "!pe-3",
      type:'number',
      render: (_, rec) => <>{ rec?.discount}</>,
    },
    {
      title: "หน่วย",
      dataIndex: "unit",
      key: "unit",
      render: (h)=><TagItemTypes data={h} />,
    },
    {
      title: "จำนวนสั่งซื้อ",
      dataIndex: "qty",
      key: "qty",
    },
    {
      title: "จำนวนที่รับแล้ว",
      dataIndex: "recamount",
      key: "recamount",
    },
    {
      title: "จำนวนค้างรับ",
      dataIndex: "remain_qty",
      key: "remain_qty",
      align: "right",
      render: (v, rec) => (
        <span style={{ color: "#cf1322", fontWeight: 600 }}>
          {v ?? (rec?.qty || 0) - (rec?.recamount || 0)}
        </span>
      ),
    },
  ]
};